{
	"page": {
		"title": "Responsible Organizations",
		"intro": "The organization that owns a registration — an NOC, the host LOC, a broadcaster. <strong>Country is optional</strong>: only national organizations have one; nationality lives on the person, never on the organization.",
		"addOrganization": "Add organization",
		"count_one": "{{n}} organization",
		"count_other": "{{n}} organizations"
	},
	"filters": {
		"searchLabel": "Name",
		"countryLabel": "Country",
		"allCountries": "All countries",
		"searchCountries": "Search countries",
		"noCountryMatches": "No countries match",
		"searchPlaceholder": "Search organizations by name",
		"typeChips": "Organization type",
		"noType": "No type"
	},
	"table": {
		"name": "Name",
		"type": "Type",
		"country": "Country",
		"cards": "Cards",
		"scopes": "Group scopes",
		"created": "Created",
		"editLabel": "Edit {{name}}",
		"deleteLabel": "Delete {{name}}",
		"cardsTitle": "Cards issued under this organization",
		"scopesTitle": "User-group scope rows that name this organization"
	},
	"pagination": {
		"summary_one": "{{from}}–{{to}} of {{total}} organization",
		"summary_other": "{{from}}–{{to}} of {{total}} organizations",
		"empty": "No organizations"
	},
	"empty": {
		"filteredTitle": "No organizations match these filters",
		"filteredDescription": "Try a broader search, or clear the filters.",
		"noneTitle": "No responsible organizations yet",
		"noneDescription": "Add the NOCs, committees and broadcasters registrations will belong to.",
		"clearFilters": "Clear filters"
	},
	"form": {
		"addTitle": "Add organization",
		"addDescription": "Registrars pick from this list when a person is registered.",
		"addSubmit": "Add organization",
		"saveChanges": "Save changes",
		"editInUse_one": "{{count}} card is issued under this organization — a change shows on it immediately.",
		"editInUse_other": "{{count}} cards are issued under this organization — a change shows on them immediately.",
		"editEmpty": "No cards are issued under this organization yet.",
		"field": {
			"name": "Name",
			"nameHint": "As it should read on lists and cards — NOC Malaysia, ABC Broadcasting.",
			"type": "Type",
			"typeHint": "What kind of organization this is. Leave blank if none fits.",
			"country": "Country",
			"countryHint": "Only national organizations — an NOC — have one. Leave blank otherwise."
		},
		"placeholder": {
			"name": "NOC Malaysia",
			"type": "No type",
			"country": "No country",
			"countryLoading": "Loading countries…",
			"typeLoading": "Loading types…"
		}
	},
	"delete": {
		"title": "Delete organization",
		"description": "Delete <strong>{{name}}</strong>? This only works while nothing references it — cards or group scopes.",
		"confirm": "Delete organization",
		"deleted": "{{name}} deleted.",
		"failed": "Couldn't delete organization"
	},
	"toast": {
		"added": "{{name}} added.",
		"updated": "{{name}} updated.",
		"addFailed": "Couldn't add organization",
		"updateFailed": "Couldn't update organization"
	},
	"errors": {
		"nameTaken": "An organization with that name already exists.",
		"invalidCountry": "That country can't be used here.",
		"invalidValue": "Invalid value",
		"invalidType": "That organization type can't be used here."
	},
	"stats": {
		"total": "Organizations",
		"matching": "matching the filters",
		"withoutCountry": "No country"
	}
}
